import api from './api';

interface ResetResult {
  success: boolean;
  deleted: {
    posts: number;
    campaigns: number;
  };
}

interface UndoResult {
  success: boolean;
  message: string;
}

interface ImportResult {
  success: boolean;
  imported: number;
  errors: string[];
}

export const calendarActionsService = {
  resetCalendar: async (
    calendarId: number,
    target: 'all' | 'posts' | 'campaigns'
  ): Promise<ResetResult> => {
    const response = await api.post(`/api/calendars/${calendarId}/reset`, { target });
    return response.data.data;
  },

  undoChanges: async (calendarId: number): Promise<UndoResult> => {
    const response = await api.post(`/api/calendars/${calendarId}/undo`);
    return response.data.data;
  },

  exportCalendar: async (
    calendarId: number,
    startDate: string,
    endDate: string,
    format: 'csv' | 'json' | 'ics'
  ): Promise<Blob> => {
    const response = await api.get(`/api/calendars/${calendarId}/export`, {
      params: { startDate, endDate, format },
      responseType: 'blob',
    });
    return response.data;
  },

  importICS: async (calendarId: number, icsContent: string): Promise<ImportResult> => {
    const response = await api.post(`/api/calendars/${calendarId}/import`, { icsContent });
    return response.data.data;
  },
};
